import React from "react";
import moment from "moment";

import { utcToDatePicker } from "../../../../utils/converters/dates-helper";
import { RPE_INTENSITY_COLORS, DATE_FORMATS } from "../../../../constants";
import { parseTime } from "../sleep-time/SleepTime";

function RPEListItem(props) {
  const { highlighted, item } = props;
  const removeMinusFromValue = (value) => {
    if (typeof value === "number" && value < 0) {
      return Math.abs(value);
    }
    return value;
  };
  return (
    <tr className={`stat-item${highlighted ? " highlighted" : ""}`}>
      {Object.keys(item).map((prop, i) => {
        let style = {};
        if (item[prop].itemClass === "rpe") {
          style = {
            color: RPE_INTENSITY_COLORS[Math.floor(item[prop].value) - 5],
          };
        }
        return (
          <td key={i}>
            {prop === "change" && item[prop].value !== 0 && (
              <img
                src={`/img/new-icons/arrow-${
                  item[prop].value > 0 ? "up-blue" : "down-green"
                }.svg`}
              />
            )}
            <span
              {...(Math.floor(item[prop].value) - 5 === 5 && {
                className: "white-label",
              })}
              {...(Math.floor(item[prop].value) - 5 !== 5 && { style })}
            >
              {prop === "sleep"
                ? parseTime(item[prop].value)
                : removeMinusFromValue(item[prop].value)}
            </span>
          </td>
        );
      })}
    </tr>
  );
}

class RPEList extends React.Component {
  constructor(props) {
    super(props);
    this.filterStatsbyDateRange = this.filterStatsbyDateRange.bind(this);
    this.scrollToHighlighted = this.scrollToHighlighted.bind(this);
    this.sortStatsByDate = this.sortStatsByDate.bind(this);
  }

  scrollToHighlighted() {
    const { list: stats, highlightedElem } = this.props;
    const highlightedIndex = stats.findIndex(
      (stat) => utcToDatePicker(stat.utcDate) === highlightedElem
    );

    const itemsContainer = document.querySelector(".stat-items");
    const containerHeight = itemsContainer.offsetHeight;
    const itemHeight = document.querySelector(".stat-item").offsetHeight;
    const scrollToItem = highlightedIndex * itemHeight;
    if (
      scrollToItem < itemsContainer.scrollTop ||
      scrollToItem > itemsContainer.scrollTop + (containerHeight - itemHeight)
    ) {
      // only scroll if the item is outside of the scroll window
      itemsContainer.scrollTop = 28 * highlightedIndex;
    }
  }

  // Just leaving this commented in case we need it in the future
  //   componentDidMount() {
  // this.scrollToHighlighted();
  //   }

  //   componentDidUpdate(prevProps) {
  //     const { highlightedElem = "" } = this.props;
  //     if (highlightedElem) {
  //       if (highlightedElem !== prevProps.highlightedElem) {
  //         this.scrollToHighlighted();
  //       }
  //     }
  //   }

  filterStatsbyDateRange(stats = []) {
    let { dateFrom, dateTo } = this.props;
    dateTo = dateTo
      ? moment(dateTo, DATE_FORMATS.DATE_PICKER_FORMAT)
      : moment(new Date());
    dateFrom = moment(dateFrom, DATE_FORMATS.DATE_PICKER_FORMAT);

    const filteredStats = stats.filter((stat) => {
      const utcDate = moment(stat.utcDate.toString(), DATE_FORMATS.UTC);
      return utcDate.isSameOrAfter(dateFrom) && utcDate.isSameOrBefore(dateTo);
    });

    return filteredStats;
  }

  filterUnsetRPE(stats = []) {
    return stats.filter((stat) => {
      return !!stat.sessionRPE;
    });
  }

  sortRecent(a, b) {
    return b.utcDate - a.utcDate;
  }
  sortOldest(a, b) {
    return a.utcDate - b.utcDate;
  }

  sortStatsByDate(stats) {
    const { sortedRecent = () => {}, updateState = () => {} } = this.props;
    if (!sortedRecent)
      return updateState({
        dateFormattedData: stats.sort(this.sortRecent),
        sortedRecent: !sortedRecent,
      });
    return updateState({
      dateFormattedData: stats.sort(this.sortOldest),
      sortedRecent: !sortedRecent,
    });
  }

  render() {
    const {
      list: stats,
      completeList,
      highlightedElem,
      columnsData = [],
      secondary = false,
      sectionClassNames = "",
    } = this.props;
    return (
      <section
        role="table-wrapper"
        data-borders-inside
        className={sectionClassNames}
      >
        <table role="table-wrapper">
          <thead className="header">
            <tr>
              {columnsData ? (
                columnsData.map((column) => {
                  return (
                    <th
                      {...(column.name === "Date" &&
                        !secondary && {
                          onClick: () =>
                            this.sortStatsByDate(completeList || stats),
                        })}
                      className={`${column.columnClass || ""} column-name ${
                        column.name
                      }`}
                    >
                      {column.name}
                      {column.name === "Date" && !secondary && (
                        <img alt="sort" src="/img/svg/up_down_arrows.svg" />
                      )}
                    </th>
                  );
                })
              ) : (
                <th></th>
              )}
            </tr>
          </thead>
          <tbody role="table-body" className="stat-items">
            {stats.map((stat) => {
              const item = {};
              for (let i = 0; i < columnsData.length; i++) {
                const elem = columnsData[i];
                item[elem.field] = {};
                item[elem.field].value = stat[elem.field];
                item[elem.field].itemClass = elem.itemClass;
                item[elem.field].unit = elem.unit || "";
              }
              const highlighted = stat.date === highlightedElem;

              return (
                <RPEListItem
                  key={stat._id}
                  highlighted={highlighted}
                  item={item}
                />
              );
            })}
          </tbody>
        </table>
      </section>
    );
  }
}

export { RPEList };
